// generated by the plop

import { PROGRESS_STATUSES, UUID } from 'symbols';
import { TemplateModel } from '../../../pdf-templates/symbols';
import { ContractModel } from '../../symbols';

export interface ContractManageStateModel {
  currentContractId: UUID;
  contracts: { [contractId: string]: ContractModel };
  loadContractStatus: PROGRESS_STATUSES;
  updateContractStatus: PROGRESS_STATUSES;
  realVersionContracts: { [contractId: string]: ContractModel };
  templateList: TemplateModel[];
  loadTemplateListStatus: PROGRESS_STATUSES;
}

export const CONTRACT_MANAGE_STATE_DEFAULT: ContractManageStateModel = {
  currentContractId: null,
  contracts: {},
  loadContractStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  updateContractStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  realVersionContracts: {},
  templateList: [],
  loadTemplateListStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
